import React from 'react';
import styled from 'styled-components';

import Typography from 'components/core/Typography/Typography';
import { Typographies } from 'models/uiElements';
import Image from 'components/widgets/Image/Image';
import {
  CDN_IMAGES_URL,
  DIGITAL_WALLET_PROVIDERS_FRIENDLY_NAME,
  DigitalWalletProvider,
  DIGITAL_WALLET_PROVIDERS_CDN_IMAGE_URL
} from 'consts';

interface IProps {
  digitalWalletProvider: DigitalWalletProvider;
}

const DemoCreatePaymentModal = ({ digitalWalletProvider }: IProps) => {
  const titles = {
    title: 'Pay with',
    subtitle: `Your customer can complete the checkout process in seconds by simply authenticating the payment with ${DIGITAL_WALLET_PROVIDERS_FRIENDLY_NAME[digitalWalletProvider]}.`
  };

  return (
    <StyledModalWrapper>
      <StyledIcon src={`${CDN_IMAGES_URL}/clo-payment.svg`} />
      <Title name="demo-modal-title" type={Typographies.H5_HEADING}>
        {titles.title}
        <StyledImg
          src={`${DIGITAL_WALLET_PROVIDERS_CDN_IMAGE_URL[digitalWalletProvider]}`}
        />
      </Title>
      <SubTitle name="demo-modal-subtitle" type={Typographies.BODY1}>
        {titles.subtitle}
      </SubTitle>
    </StyledModalWrapper>
  );
};

export default DemoCreatePaymentModal;

const StyledModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey.grey100};
`;

const StyledIcon = styled.img`
  width: 4.8rem;
  height: 4.8rem;
`;

const Title = styled(Typography)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6rem;
`;

const SubTitle = styled(Typography)`
  display: block;
  text-align: center;
  padding: ${({ theme }) =>
    theme.view.isMobile ? '0 2rem 2rem 2rem' : '0 10rem 2rem 10rem'};
`;

const StyledImg = styled(Image)`
  margin-left: 1rem;
  width: 6rem;
`;
